import { auth } from '@/plugins/firebase'
import scheduleService from '@/services/scheduleService'

export default {
  ifAuthenticated () {
    return new Promise((resolve, reject) => {
      const unsubscribe = auth.onAuthStateChanged(
        user => {
          unsubscribe()
          resolve(!!user)
        }
      )
    })
  },
  login: async ({ commit }, { email, password }) => {
    const { user } = await auth.signInWithEmailAndPassword(email, password)
    commit('SET_USER', user)
  },
  logout: async ({ commit }) => {
    await auth.signOut()
    commit('SET_USER', null)
  },

  fetchMyUserTeacher: async ({ commit }) => {
    const currentUser = auth.currentUser
    if (!currentUser) {
      commit('SET_MY_TEACHER_USER', null)
      return null
    }

    // Verificar si es super admin (usuario autenticado directamente en Firebase)
    const adminEmails = ['admin@gmail.com'] // Correo de super admin actualizado
    if (adminEmails.includes(currentUser.email)) {
      // Obtener el nombre del correo (antes del @) para usarlo como nombre
      const emailName = currentUser.email.split('@')[0]
      const adminUser = {
        id: 'admin',
        uid: currentUser.uid,
        email: currentUser.email,
        firstName: emailName.split('.')[0] || 'Admin',
        lastName: emailName.split('.')[1] ? emailName.split('.').slice(1).join(' ') : 'User',
        role: 'admin'
      }
      commit('SET_MY_TEACHER_USER', adminUser)
      return adminUser
    }

    // Buscar el docente en Firestore
    const teacher = await scheduleService.getMyTeacherUser()
    if (teacher) {
      // Asegurarse de que el rol esté establecido
      if (!teacher.role) {
        teacher.role = 'teacher' // Rol por defecto para docentes
      }
      commit('SET_MY_TEACHER_USER', teacher)
      return teacher
    }

    // Si no se encuentra el docente pero el usuario está autenticado, cerrar sesión
    await auth.signOut()
    commit('SET_MY_TEACHER_USER', null)
    return null
  }
}
